$(document).ready(function () {
  $('.generalmessage').prependTo('header');

  customTicketButton();
  getNavItem();
  createBurgerIcon();
  customSearchBar();
  createCustomSignup();
});

// --------------------------------
// Custom burger menu
function createBurgerIcon() {
  $.each(new Array(3), function () {
    $('.header .mobile-nav-toggle').append('<span class="burger-line"></span>');
  });
}

// Searchbox scripts
function customSearchBar() {
  let searchPlaceholder = 'Search Website';

  $('.header .searchBox input').val('');
  $('.header .searchBox input').attr('placeholder', searchPlaceholder);
}

function customTicketButton() {
  const ticketButton = $('.header .ticket-button').text();

  if (ticketButton.length === 0) {
    $('.header .items-container').addClass('no-tkt-btn');
    $('.header .nav-items').addClass('no-tkt-btn');
  }
}

// function to validate external Links
export function isLocalUrl(urlToCheck) {
  const clientPath = SITEBASEURL;
  return urlToCheck !== null && urlToCheck.includes(clientPath);
}

export function validateWindowSize(breakpointValue) {
  const breakpoint = breakpointValue;
  return $(window).width() >= breakpoint;
}

function getNavItem() {
  $('#mainNavigation .groups .group').each(function () {
    const firstValidItem = $(this).find('.item').not('.navClonedItem').first();
    firstValidItem.addClass('not-cloned-first');
  });
}

function createCustomSignup() {
  $('.tier-5-container').append('<span class="signup-abstract"></span>');

  const $signupElement = $('.tier-5-container .emailSignup');
  const $signupInput = $signupElement.find('input');

  $signupElement.find('.emailSignupText').remove();
  $signupElement.find('.emailSignupText').remove();
  $signupInput.val('');
  $signupInput.attr('placeholder', 'Email Address');
  $signupElement.find('.emailInputSubmit a').text('Sign Up');

  $signupElement
    .find('.emailInputField, .emailInputSubmit')
    .wrapAll('<div class="input-wrap"></div>');
}
